import { cn } from '@blimo/ui';

/**
 * Switch (shadcn look). The real control is a native checkbox with `role="switch"` stretched over the track
 * (keyboard, screen reader and a larger hit area for free); track and thumb are drawn around it.
 * @param {Omit<import('react').ComponentProps<'input'>, 'type'|'onChange'> & { checked: boolean, onCheckedChange: (checked: boolean) => void }} props
 */
export function Switch({ checked, onCheckedChange, className, ...props }) {
  return (
    <span
      data-slot="switch"
      className={cn(
        'relative inline-flex h-5 w-9 shrink-0 items-center rounded-full bg-input transition-colors has-checked:bg-primary has-disabled:opacity-50 has-focus-visible:outline-2 has-focus-visible:outline-offset-2 has-focus-visible:outline-ring',
        className,
      )}
    >
      <input
        type="checkbox"
        role="switch"
        aria-checked={checked}
        checked={checked}
        onChange={(e) => onCheckedChange(e.target.checked)}
        className="peer absolute -inset-2 z-10 m-0 size-[calc(100%+1rem)] cursor-pointer opacity-0 focus-visible:outline-none disabled:cursor-not-allowed"
        {...props}
      />
      <span
        aria-hidden="true"
        className="pointer-events-none ml-0.5 size-4 rounded-full bg-white shadow-sm ring-1 ring-black/5 transition-transform peer-checked:translate-x-4"
      />
    </span>
  );
}
